import * as React from 'react';

import { getMapYears } from '../../../../utils/map';
import { Year } from '../Year/Year';
import * as styles from './YearsService.css';
import { IconButton, IconClose16, UIHeading2, UIText3 } from '@cian/ui-kit';

interface IYearsServiceProps {
  selectedYear: number;
  nextAvailableYear: number | null;
  onChange: (value: number) => void;
  onClose: () => void;
  isFullscreen: boolean;
}

export const YearsService: React.FC<IYearsServiceProps> = ({
  selectedYear,
  onChange,
  onClose,
  nextAvailableYear,
  isFullscreen,
}) => {
  const mapYears = getMapYears();

  return (
    <div className={styles['base']} data-testid="MapYearsService">
      <div className={styles['close-button']} aria-label="Закрыть">
        <IconButton icon={<IconClose16 />} onClick={onClose} />
      </div>
      <UIHeading2>Развитие инфраструктуры</UIHeading2>
      <div className={styles['warning']}>
        <UIText3 color="gray60_100">Данные могут быть неточными</UIText3>
      </div>
      <div className={styles['years']}>
        {mapYears.map(year => (
          <Year
            key={year}
            year={year}
            onChange={onChange}
            checked={year === selectedYear}
            nextAvailableYear={nextAvailableYear}
            isFullscreen={isFullscreen}
          />
        ))}
      </div>
    </div>
  );
};
